import { useDownloadGstInvoices } from "@entities/financeApproval/lib/hooks/useDownloadGstInvoices";
import { ToastService } from "@shared/lib/services";
import { Button, DatePicker, Typography } from "@shared/ui";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";

const { RangePicker } = DatePicker;
const { Text } = Typography;

interface IDownloadGstInvoicesProps {
  onClose: () => void;
}

type DateRange = [Dayjs | null, Dayjs | null] | null;

export function DownloadGstInvoices({ onClose }: IDownloadGstInvoicesProps) {
  const {
    downloadGstInvoices,
    isDownloadingGstInvoicesLoading,
    isDownloadingGstInvoicesSuccess,
  } = useDownloadGstInvoices();

  const [dateRange, setDateRange] = useState<DateRange>([
    dayjs().startOf("day"),
    dayjs().endOf("day"),
  ]);

  const handleDateRangeChange = (value: DateRange) => {
    if (!value?.[0] || !value?.[1]) {
      setDateRange(value);
      return;
    }

    setDateRange([
      value[0].startOf("day"),
      value[1].endOf("day"),
    ]);
  };

  useEffect(() => {
    if (isDownloadingGstInvoicesSuccess) {
      ToastService.success("Gst invoices downloaded successfully");

      onClose();
      setDateRange(null);
    }
  }, [isDownloadingGstInvoicesSuccess]);

  const handleSubmit = () => {
    const [from, to] = dateRange ?? [null, null];
    if (!from || !to) {
      ToastService.error("Please select a date range");
      return;
    }

    downloadGstInvoices({
      invoiceDate: {
        from: from.startOf("day").toISOString(),
        to: to.endOf("day").toISOString(),
      },
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.field}>
        <Text strong>Select Date Range</Text>
        <RangePicker
          value={dateRange}
          onChange={(value) => handleDateRangeChange(value as DateRange)}
          format="DD MMM YYYY"
          picker="date"
          allowClear
          disabled={isDownloadingGstInvoicesLoading}
          className={styles.rangePicker}
        />
      </div>

      <div className={styles.actions}>
        <Button onClick={onClose} disabled={isDownloadingGstInvoicesLoading}>
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={handleSubmit}
          loading={isDownloadingGstInvoicesLoading}
          disabled={!dateRange?.[0] || !dateRange?.[1]}
        >
          Submit
        </Button>
      </div>
    </div>
  );
}
